// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2N3w7","loaderOuter":"PageOverlayLoader_loaderOuter__31x3R"};